
webpack.register(
    'components/leaderboard/drawer/drawer',
    function() {
        return require('components/leaderboard/drawer/drawer');
    },
    false
);
webpack.register(
    'components/video-landing/live-video-drawer/featured-slider/featured-slider',
    function() {
        return require('components/video-landing/live-video-drawer/featured-slider/featured-slider');
    },
    false
);
webpack.register(
    'components/fetching-loader/fetching-loader',
    function() {
        return require('components/fetching-loader/fetching-loader');
    },
    false
);
var stache = require('can/view/stache/stache');
module.exports = stache("<can-import from=\"components/leaderboard/drawer/drawer\" />\r\n<can-import from=\"components/video-landing/live-video-drawer/featured-slider/featured-slider\" />\r\n<can-import from=\"components/fetching-loader/fetching-loader\" />\r\n\r\n<div class=\"c-featured-group\">\r\n    <div class=\"c-featured-group__title\">{{channelName}}</div>\r\n    {{#if drawerData}}\r\n        {{^if fetching}}\r\n            <featured-slider\r\n                {data}=\"swiperData\"\r\n                {current-item}=\"currentPlayer\"\r\n                (set-current)=\"setCurrent(identifier)\"\r\n            />\r\n            {{#if showDrawer}}\r\n                <leaderboard-drawer {data}=\"drawerData\" {type}=\"DRAWER_TYPES.LIVE\"></leaderboard-drawer>\r\n            {{/if}}\r\n        {{/if}}\r\n    {{/if}}\r\n</div>");